module.exports = __webpack_public_path__ + "img/exclamation.f125832c.svg";